import { createFileRoute } from '@tanstack/react-router';
import { ReimbursementsModule } from '@/modules/reimbursement';

export const Route = createFileRoute('/(dashboard)/_dashboard/finance/reimbursement/')({
  component: ReimbursementsModule,
});
